import { PulseLoader } from "react-spinners";

const LoadingOverlay = ({ message = "Saving..." }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-4 rounded-lg flex items-center space-x-3">
            <PulseLoader color="#2563eb" size={8} margin={2} />
            <span className="text-gray-700">{message}</span>
        </div>
    </div>
);

export default LoadingOverlay; 